import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionProps {
  title: React.ReactNode;
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  theme?: 'dark' | 'gold' | 'light';
}
export function Accordion({
  title,
  isOpen,
  onToggle,
  children,
  theme = 'dark'
}: AccordionProps) {
  const getThemeClasses = () => {
    switch (theme) {
      case 'gold':
        return 'bg-lsa-gold text-lsa-dark border-lsa-dark/10';
      case 'light':
        return 'bg-white text-lsa-dark border-gray-200 shadow-sm';
      case 'dark':
      default:
        return 'bg-lsa-dark text-white border-white/10';
    }
  };
  const getIconColor = () => {
    switch (theme) {
      case 'gold':
      case 'light':
        return 'text-lsa-dark';
      case 'dark':
      default:
        return 'text-white';
    }
  };
  return <div className={`border rounded-xl overflow-hidden mb-3 transition-colors duration-200 ${getThemeClasses()}`} data-id="element-18">
      <button onClick={onToggle} className="w-full flex items-center justify-between p-4 text-left focus:outline-none" data-id="element-19">
        <div className="flex-1 pr-4 font-semibold text-[15px] sm:text-base leading-snug" data-id="element-20">
          {title}
        </div>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className={`flex-shrink-0 ${getIconColor()}`} data-id="element-21">
          <ChevronDown size={20} data-id="element-22" />
        </motion.div>
      </button>

      <AnimatePresence initial={false} data-id="element-23">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-24">
            <div className="p-4 pt-0 border-t border-current/10" data-id="element-25">
              {children}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}